const theme = {
    colors : {
        background: "#3a424c",
        surface: "#46505b",
        primary: "#7fbfd0",
        primaryHover: "#95d4e5",

        text: "#f8fafc",
        textSecondary: "#cbd5e1",

        border: "#rgba(255, 255, 255, 0.08",
    },

    spacing: {
        xs: "4px",
        sm: "8px",
        md: "16px",
        lg: "24px",
        xl: "48px",
        xxl: "96px",
    },

    borderRadius: {
        sm: "8px",
        md: "12px",
        lg: "20px",
        xl: "28px",
    },

    shadows: {
        card: "0 15px 40px rgba(0,0,0,.25)",
        button : "0 10px 30px rgba(127, 192, 208, .25",
    },
};

export default theme;